import { Card, CardBody, Col, Container, Form, FormGroup, Input, Label, Row } from 'reactstrap'
import CommonCardHeader from '../../CommonElements/CommonCardHeader/CommonCardHeader'
import { BillingDetails, Checkouts, Ecommerce } from '../../utils/Constant'
import Breadcrumbs from '../../CommonElements/Breadcrumbs/Breadcrumbs'
import ProductCheckout from './ProductCheckout/ProductCheckout'
import CheckoutForm from './CheckoutForm/CheckoutForm'

const CheckoutContainer = () => {
  return (
    <div className='page-body'>
      <Breadcrumbs mainTitle={Checkouts} parent={'Ventes'} />
      <Container fluid>
        <Row>
          <Col xl="6" sm="12">
            <Card>
              <CommonCardHeader title={"Information Client"} />
              <CardBody className='checkbox-checked'>
                <CheckoutForm />
              </CardBody>
            </Card>
          </Col>
          <Col xl="6" sm="12">
            <Card>
              <CommonCardHeader title={"Detail vente"} />
              <CardBody className='checkbox-checked'>
                <ProductCheckout />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default CheckoutContainer